import { Action, Dispatch } from 'redux';
import { IAppState } from '../../../state/reducers';
import { getAsset } from '../../../api/vault/assets';
import { generateAssetMediaInformation } from '../../../utils/assetDetails/generateAssetMediaInformation';
import { ILookupOption, updateLookupByName } from '../../../state/lookups';
import { getScheduleById, IExchangeSchedule } from '../../../api/vault/exchangeSchedule';

export enum ActionType {
  UpdateMediaInformation = 'Clipper.UpdateMediaInformation',
  UpdateVideoTimeStamp = 'Clipper.updateVideoTimeStamp',
}

export interface IMediaContentAction extends Action<ActionType> {
  payload?: any;
}

export interface IState {
  assetId?: string,
  sourceUrl?: string,
  timeStamp: number,
  assetDetails: any,
  isExchangeLiveEvent?: boolean,
  exchangeSchedule: IExchangeSchedule | null,
}

const INITIAL_STATE: IState = {
  assetId: null,
  sourceUrl: null,
  timeStamp: 0,
  assetDetails: null,
  isExchangeLiveEvent: false,
  exchangeSchedule: null,
};

export default function reducer(state = INITIAL_STATE, action: IMediaContentAction) {
  switch (action.type) {
    case ActionType.UpdateMediaInformation:
      return {
        ...state,
        ...action.payload,
      };
    case ActionType.UpdateVideoTimeStamp:
      return {
        ...state,
        timeStamp: action.payload,
      };
    default:
      return state;
  }
}

export const updateMediaInformation = (assetId: string, timeStamp: number) => async (
  dispatch: Dispatch<IMediaContentAction>,
  getState: () => IAppState,
) => {
  const asset = (await getAsset(assetId)).data.data;
  const assetMediaInformation = await generateAssetMediaInformation(asset);

  // Get schedule info and refresh lookups for correct exchange qualifiers
  const isExchangeLiveEvent = !!asset.exchangeLiveStreamScheduleId;
  let exchangeSchedule;
  if (isExchangeLiveEvent) {
    exchangeSchedule = (await getScheduleById(asset.exchangeLiveStreamScheduleId)).data.data;
    await updateLookupByName('exchangeQualifier', exchangeSchedule.Sport)(dispatch, getState);
  }

  dispatch({
    type: ActionType.UpdateMediaInformation,
    payload: {
      assetId,
      sourceUrl: assetMediaInformation.source,
      timeStamp,
      assetDetails: asset,
      isExchangeLiveEvent,
      exchangeSchedule: isExchangeLiveEvent ? exchangeSchedule : null,
    },
  });
};

export const updateVideoTimeStamp = (timeStamp: number) => ({
  type: ActionType.UpdateVideoTimeStamp,
  payload: timeStamp,
});

export const resetVideoTimeStamp = () => ({
  type: ActionType.UpdateVideoTimeStamp,
  payload: 0,
});

export const selectSource = (state: IAppState) => state.clipperMediaContent.sourceUrl;
